module.exports = __webpack_public_path__ + "static/07-c4f6b76c23e2072f347ce9e5c79612fc.jpg";